import { FC, ReactElement } from 'react';
import { Box, Container, Divider, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export const Footer: FC = (): ReactElement => (
  <Box sx={{ width: '100%', p: 2 }}>
    <Divider />
    <Container maxWidth="lg" sx={{ pt: 2 }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        spacing={2}
      >
        <Box>
          <Typography
            variant="subtitle1"
            fontWeight={700}
            color="secondary.main"
          >
            DealerScout
          </Typography>
          <Typography color="textSecondary" variant="caption">
            &copy; {new Date().getFullYear()} DealerScout. Free for buyers,
            always.
          </Typography>
        </Box>
        <Stack direction="row" spacing={3}>
          <Typography variant="subtitle2">
            <Link to="/dealer" style={{ textDecoration: 'none' }}>
              For Dealers
            </Link>
          </Typography>
          <Typography variant="subtitle2">
            <Link to="/login" style={{ textDecoration: 'none' }}>
              Log In
            </Link>
          </Typography>
        </Stack>
      </Stack>
    </Container>
  </Box>
);

export default Footer;
